import { createChunk, createNotFoundChunk } from '../Chunks';
import { joinPaths, createURLDescriptor } from '../URLTools';
import { createChunksMatcher } from '../createChunksMatcher';
export function redirect(maybeResolvableTo) {
    return createChunksMatcher(maybeResolvableTo, undefined, function (to, request) {
        var unmatchedPathnamePart = request.path;
        if (unmatchedPathnamePart && unmatchedPathnamePart !== '/') {
            return [createNotFoundChunk(request)];
        }
        // TODO: support all relative URLs
        var toHref;
        if (typeof to === 'string') {
            if (to.slice(0, 2) === './') {
                toHref = joinPaths(request.mountpath.split('/').slice(0, -1).join('/'), to.slice(2));
            }
            else {
                toHref = to;
            }
        }
        else if (to) {
            toHref = createURLDescriptor(to).href;
        }
        return toHref ? [createChunk('redirect', request, { to: toHref })] : [];
    });
}
//# sourceMappingURL=redirect.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/navi/dist/es/matchers/redirect.js
// module id = 106
// module chunks = 0